export enum CustomerOrderBy {
	Id = 'Id',
	Name = 'Name',
}
